import PropTypes from 'prop-types'
import React from 'react'

const Weather = ({ temperatureCompared, temperatureCurrent, weatherIconCompared, weatherIconCurrent }) => (
  <div className="weather">
    <div className="store-result-weather">
      {typeof temperatureCurrent === 'number' ? <div className="temperature temperature_current">{temperatureCurrent}℃</div> : '-'}
      <div className={`fm fm-${weatherIconCurrent}`} />
    </div>
    <div className="separator">/</div>
    <div className="store-result-weather store-result-weather_compared">
      {typeof temperatureCompared === 'number' ? <div className="temperature">{temperatureCompared}℃</div> : '-'}
      <div className={`fm fm-${weatherIconCompared}`} />
    </div>
  </div>
)

Weather.propTypes = {
  temperatureCompared: PropTypes.number,
  temperatureCurrent: PropTypes.number,
  weatherIconCompared: PropTypes.string,
  weatherIconCurrent: PropTypes.string,
}

export default Weather
